import axios from 'axios';
import {clarify} from "../utils/clear";

class PageApi {
    constructor() {
        this.endpoint = process.env.VUE_APP_BASE_API;
    }


    list(body) {
        const params = new URLSearchParams(clarify(body));
        return axios.get(`${this.endpoint}/pages`, {params}).then(response=>response.data);
    }

    get(pageId) {
        return axios.get(`${this.endpoint}/pages/${pageId}`, {}).then(response=>response.data);
    }

    save(page) {
        return axios.post(`${this.endpoint}/pages/save`, page).then(response=>response.data);
    }

    delete(pageId) {
        return axios.delete(`${this.endpoint}/pages/delete/${pageId}`, {}).then(response=>response.data);
    }

    uploadImage(f) {
        const formData = new FormData();
        formData.append('file', f);
        return axios.post(`${this.endpoint}/pages/upload/image`, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(response => response.data);
    }

}


export default new PageApi();
